<template>
	<div class="intro-container">
		<div>
			<h2>Router errors</h2>
			<router-link class="btn btn-sm btn-danger" to="/not-found">Force 404 error</router-link>
			<router-link class="btn btn-sm btn-danger ml-3" to="/error-view">Page with instant error (ErrorView)</router-link>
		</div>
		<div>
			<h2>JS errors</h2>
			<button class="btn btn-sm btn-danger" v-on:click="forceJsSyntaxError">Force js syntax error</button>
			<button class="btn btn-sm btn-danger ml-3" v-on:click="forceJsUnknownFunction">Force js unknown function</button>
			<button class="btn btn-sm btn-danger ml-3" v-on:click="throwJsError">Throw js error</button>
			<button class="btn btn-sm btn-danger ml-3" v-on:click="throwBadError">Throw non standard js error</button>
		</div>
		<div>
			<h2>Ajax errors</h2>
			<button class="btn btn-sm btn-danger mr-3 mb-3" v-on:click="forceAjaxError('timeout')">Force ajax error (120 seconds timeout)</button>
			<button class="btn btn-sm btn-danger mr-3 mb-3" v-on:click="forceAjaxError(404)">Force ajax error (404)</button>
			<button class="btn btn-sm btn-danger mr-3 mb-3" v-on:click="forceAjaxError(500)">Force ajax error (500)</button>
			<button class="btn btn-sm btn-danger mr-3 mb-3" v-on:click="forceAjaxError('exception')">Force ajax error (exception)</button>
			<button class="btn btn-sm btn-danger mr-3 mb-3" v-on:click="forceAjaxError('error')">Force ajax error (error)</button>
		</div>

	</div>
</template>

<script>
	import * as MutationTypes from '@/store/mutation-types'
	import {mapGetters} from 'vuex';

	export default {
		name: 'dev-failonpurpose-view',
		components: {
		},
		methods: {
			forceJsSyntaxError() {
				eval('this is not valid js, and is therefore a syntax error!');
			},
			forceJsUnknownFunction() {
				_____unknownFunctionCall938365('yep, indeed an unknown function');
			},
			throwJsError() {
				throw new Error('this is a thrown JS error - hopefully caught by our handler');
			},
			throwBadError() {
				throw new NotAnError('this is a thrown JS error - hopefully caught by our handler');
			},
			okAjax(type) {
				this.$apiClient.loadData();
			},
			forceAjaxError(type) {
				this.$apiClient.forceAjaxError(type);
			},

		},
	}
</script>
